import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import ConfigContext from '../../../contexts/ConfigContext';

// Components
import Hero from '../content/Hero';
import LogoList from '../content/LogoList';
import Meta from '../../shared/Meta';
import FeaturedTrucks from '../FeaturedTrucks';
import CtaImage from '../content/CtaImage';
import AnyEvent from '../content/AnyEvent';
import HowItWorks from '../content/HowItWorks';
import CommunityFaq from '../faqs/CommunityFaq';

import styles from '../../../../stylesheets/public/layouts/AboutPage.module.postcss';

function CommunityEvents() {
  const { vehicle_type, site_title, city_name } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  return (
    <div className='CateringPage'>
      <Meta
        title={`Food ${vehicle_type}s for Events & Festivals`}
        type='website'
        canonical='/food-truck-catering/community-events'
        image='https://static.seattlefoodtruck.com/photos/Community_Events__HEADER.jpeg'
        description={`Book food ${vehicleType}s for events and festivals in ${city_name}. Block parties, fundraisers, and large-scale festivals. Get free quotes for crowds of any size.`}
        structuredData={{
          cateringService: {
            name: `Food ${vehicle_type}s for Events & Festivals in ${city_name}`,
            description: `Book food ${vehicleType}s for events and festivals in ${city_name}. Block parties, fundraisers, and large-scale festivals.`,
            url: '/food-truck-catering/community-events',
            serviceType: 'Food Truck Event Catering',
          },
          breadcrumbs: {
            listItems: [
              { '@type': 'ListItem', position: 2, name: 'Catering', item: '/catering' },
              { '@type': 'ListItem', position: 3, name: 'Events & Festivals', item: '/food-truck-catering/community-events' }
            ]
          }
        }}
      />

      <Hero photo='https://static.seattlefoodtruck.com/photos/Community_Events__HEADER.jpeg'>
        <h1>Food {vehicle_type}s for Events &amp; Festivals</h1>
        <p>Whether it&#39;s a store opening, neighborhood block party, or school <Link to='/food-truck-catering/fundraiser'>fundraiser</Link>, food {vehicleType}s are a good addition to any event. Planning a <Link to='/food-truck-catering/private-parties'>private party</Link> or <Link to='/food-truck-catering/special-occasions'>special occasion</Link>? We&#39;ve got you covered. Use our request form below to connect with {city_name}&#39;s best food {vehicleType}s!</p>
        <Link to='/catering/register' className='Button'>
          Get started
        </Link>
      </Hero>

      <HowItWorks
        className='Section'
        title1='1. Tell Us About Your Event'
        text1={`Answer a few questions about your upcoming event and what kind of food ${vehicleType}s you're looking for with our free online form.`}
        title2={`2. Compare Available ${vehicle_type}s`}
        text2={`Receive availability and quotes from ${city_name}'s best food ${vehicleType}s. Chat with vendors directly and discuss logistics and details.`}
        title3={`3. Book Your ${vehicle_type}s`}
        text3={`Once you've settled on your favorite food ${vehicleType}, book them directly without any added commission or service fees.`}
      />

      <section className='Section--extraPadding'>
        <div className={styles.Cta}>
          <CtaImage image='https://static.seattlefoodtruck.com/photos/Events1.jpeg' />
          <div className={styles.Cta_copy}>
            <h4>Bring the fun to any event</h4>

            <p>Festivals, markets, and block parties need a simple way to feed their guests, without too many moving parts. That&#39;s why they use {city_name}&#39;s best food {vehicleType}s to help! Food {vehicleType}s are the perfect way to feed a hungry crowd of any size, from 50 to 50,000! Whether you&#39;re looking to book one or ten {vehicleType}s, {site_title} gives you access to over 500 food {vehicleType}s to choose from! Choose from cuisines all over the world, giving your guests something to enjoy, while supporting small businesses along the way.</p>

            <div>
              <Link to='/catering/register' className='Button'>
                Free Quote
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className='Section--extraPadding'>
        <div className={styles.Cta + ' ' + styles.Cta__reversed}>
          <CtaImage image='https://static.seattlefoodtruck.com/photos/Events2.jpeg' />
          <div className={styles.Cta_copy}>
            <h4>Gourmet Food On Wheels</h4>

            <p>Give your music festival an upgrade from fair food with gourmet kitchens on wheels. Treat your neighborhood block party to an ice cream sandwich social with Street Treats food {vehicleType}! Complement your store opening with fresh made-to-order beignets from {city_name} favorite, Where Ya At Matt food {vehicleType}! Delight parents and faculty at your school fundraiser with authentic Oaxacan tacos from the El Cabrito food {vehicleType}. Whatever your event, the possibilities are endless and these {city_name} food {vehicleType}s are only a click away! Use our free catering form below to start your request.</p>

            <div>
              <Link to='/catering/register' className='Button'>
                Book a Food {vehicle_type}
              </Link>
            </div>
          </div>
        </div>
      </section>

      <FeaturedTrucks />

      <section className='Section'>
        <LogoList community />
      </section>

      <AnyEvent />

      <section className='Section--extraPadding'>
        <CommunityFaq />
      </section>

      <section className='Section'>
        <div className={styles.BookingCta}>
          <h3>Think of us for your next event</h3>
          <p>Free no-obligation estimates from {city_name}&#39;s best food {vehicleType}s.</p>
          <Link
            className='Button'
            to='/catering/register'
          >
            Food {vehicle_type} Catering
          </Link>
        </div>
      </section>
    </div>
  );
}

export default CommunityEvents;
